import { Reveal, Kicker } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";
import { IMG } from "@/constants/assets";

export function Manifesto() {
  const { t } = useLanguage();
  const chapters = [
    { n: "01", title: t("ch1t"), desc: t("ch1d"), img: IMG.carving },
    { n: "02", title: t("ch2t"), desc: t("ch2d"), img: IMG.shutter },
    { n: "03", title: t("ch3t"), desc: t("ch3d"), img: IMG.sculptor },
    { n: "04", title: t("ch4t"), desc: t("ch4d"), img: IMG.window },
  ];

  return (
    <section id="savoir-faire" data-testid="manifesto-section" className="relative py-28 md:py-40 bg-[#0B0A08]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal><Kicker>{t("man_kicker")}</Kicker></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif-d text-4xl md:text-6xl mt-6 max-w-3xl text-[#F7F4EE]">{t("man_title")}</h2>
        </Reveal>

        <div className="mt-20 md:mt-28 space-y-24 md:space-y-36">
          {chapters.map((c, i) => (
            <div key={c.n} className={`grid md:grid-cols-12 gap-8 md:gap-12 items-center ${i % 2 === 1 ? "" : ""}`}>
              <Reveal className={`md:col-span-5 ${i % 2 === 1 ? "md:order-2" : ""}`} y={60}>
                <div className="img-frame aspect-[4/3]">
                  <img src={c.img} alt={c.title} className="w-full h-full object-cover" loading="lazy" />
                </div>
              </Reveal>
              <div className={`md:col-span-7 ${i % 2 === 1 ? "md:order-1 md:pr-8" : "md:pl-8"}`}>
                <Reveal delay={0.15}>
                  <span className="font-serif-d text-7xl md:text-8xl gold-text opacity-90 leading-none">{c.n}.</span>
                </Reveal>
                <Reveal delay={0.25}>
                  <h3 className="font-serif-d text-2xl md:text-4xl mt-4 text-[#F7F4EE]">{c.title}</h3>
                </Reveal>
                <Reveal delay={0.35}>
                  <p className="mt-5 text-sm md:text-base text-[#B8B0A2] leading-relaxed max-w-lg">{c.desc}</p>
                </Reveal>
                <Reveal delay={0.45}>
                  <span className="block mt-8 h-px w-24 bg-[#C5A059]/50" />
                </Reveal>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
